import { HttpClient } from '@angular/common/http';
import { Injectable, makeStateKey, StateKey, inject } from '@angular/core';

import { Observable, of, catchError } from 'rxjs';

import { ConfigService, SentryLogger, StateTransferService } from '@fcom/core/services';

import { AmDestinationResponseItem } from '../interfaces/destination-search.interface';

@Injectable()
export class AmDestinationService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);
  private sentryLogger = inject(SentryLogger);
  private stateTransferService = inject(StateTransferService);

  static createStateKey = (): StateKey<AmDestinationResponseItem[]> =>
    makeStateKey<AmDestinationResponseItem[]>('amdestinations');

  public amDestinationList(): Observable<AmDestinationResponseItem[]> {
    if (this.configService.cfg.buildEnv === 'prod') {
      return this.stateTransferService.wrapToStateCache(AmDestinationService.createStateKey(), () =>
        this.fetchAmDestinationList()
      );
    }
    return this.fetchAmDestinationList();
  }

  private fetchAmDestinationList(): Observable<AmDestinationResponseItem[]> {
    const apiUrl = this.configService.cfg.amFlightHotelDestinationUrl;
    const apiUrlLocalized = `${apiUrl}?dep=HEL`;
    return this.http.get<AmDestinationResponseItem[]>(apiUrlLocalized).pipe(
      catchError((err: unknown) => {
        if (['prod', 'staging'].includes(this.configService.cfg.buildEnv)) {
          this.sentryLogger.warn('Failed to fetch AM flight + hotel list', { error: err });
        }
        return of([]);
      })
    );
  }
}
